import { Button } from '@bfa/base-ui';
import React from 'react';
import { AnalyticsLink } from '../../../../../../../components/Analytics';
import { REFRESHMENTS_URLS } from '../../../../../../../constants';
import { SUBSCRIBED_LANDING_NEXT_SHIPMENT_SUMMARY_SECTION_EVENTS as EVENTS } from '../../../../../../../utils/analytics/events';
import { BottomDescription, BottomDescriptionWrapper, ButtonsWrapper, Container, Description, SubTitle, SummaryContainer, SummaryHeaderContainer, Title, } from '../../DetailedNextShipmentSummary.styled';
import SummaryItem from '../SummaryItem';
import useStarterKitShipmentSummary from './useStarterKitShipmentSummary';
var StarterKitShipmentSummary = function (_a) {
    var content = _a.content, item = _a.item, subscription = _a.subscription;
    var title = content.title, bottomDescription = content.bottomDescription;
    var _b = useStarterKitShipmentSummary(content, subscription), subtitle = _b.subtitle, description = _b.description;
    return (React.createElement(Container, { "data-testid": "sk-shipment-summary-section" },
        React.createElement(SummaryContainer, { "data-testid": "starter-kit-shipment-summary-section" },
            React.createElement(SummaryHeaderContainer, null,
                React.createElement(Title, null, title),
                React.createElement(SubTitle, null, subtitle),
                React.createElement(Description, null, description)),
            React.createElement(SummaryItem, { item: item })),
        React.createElement(BottomDescriptionWrapper, null,
            React.createElement(BottomDescription, { bold: true }, bottomDescription)),
        React.createElement(ButtonsWrapper, null,
            React.createElement(AnalyticsLink, { eventData: EVENTS.CLICK_ON_MANAGE_ITEMS_LINK, href: REFRESHMENTS_URLS.MANAGE_ITEMS, passHref: true },
                React.createElement(Button, { variant: "secondary", "data-testid": "manage-shipments-button", small: true }, content.secondaryButtonText)))));
};
export default StarterKitShipmentSummary;
